function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M122 480h268V116H122zm12-352h244v340H134z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M160 180h112v12H160zM160 212h80v12h-80zM160 260h192v12H160zM160 292h192v12H160zM160 356h192v12H160zM192 388h128v12H192zM160 324h192v12H160z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M326 68V32h-32V0h-76v32h-32v36H90v444h332V68zM198 44h32V12h52v32h32v40H198zm212 456H102V80h84v16h140V80h84z"
});

function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2, _ref3);
}

export default SvgReport;